import {useFocus} from 'focus-manager/web';
import * as React from 'react';

import ReservedValue from '../Constants/ReservedValue';
import Backspace from '../Icons/Backspace';
import Shift from '../Icons/Shift';
import IKey from '../Interfaces/IKey';

import ScalableText from './ScalableText';

interface IKeyProps extends IKey {
    onSelect: (keyValue: string) => void;
    disableFocus?: boolean;
    isUpperCased?: boolean;
    isSpecialChars?: boolean;
}

const getVisibleValue = (value: string, isUpperCased?: boolean, isSpecialChars?: boolean) =>
    ({
        [ReservedValue.BACKSPACE]: '',
        [ReservedValue.SHIFT]: '',
        [ReservedValue.TOGGLE_KEY_SET]: isSpecialChars ? 'abc' : '!?#$%',
    }[value] ?? (isUpperCased ? value.toUpperCase() : value));

const getIcon = (value: string) => {
    switch (value) {
        case ReservedValue.BACKSPACE:
            return Backspace;
        case ReservedValue.SHIFT:
            return Shift;
        default:
            return null;
    }
};

const Key: React.FC<IKeyProps> = ({basis, disableFocus, isUpperCased, isSpecialChars, onSelect, value, anchors}) => {
    const Icon = getIcon(value);
    const handleSelect = () => onSelect(isUpperCased ? value.toUpperCase() : value);

    const {setFocusableElementRef} = useFocus({
        disableFocus,
        focusableBasis: basis,
        focusableAnchors: anchors,
        onSelect: handleSelect,
    });

    const className = ['key', basis && `key--basis-${basis}`].filter(Boolean).join(' ');

    return (
        <button type="button" disabled={disableFocus} ref={setFocusableElementRef} className={className}>
            {Icon ? <Icon /> : <ScalableText>{getVisibleValue(value, isUpperCased, isSpecialChars)}</ScalableText>}
        </button>
    );
};

export default React.memo(Key);
